export const environment = {
  AppConfig: {
    BaseURL: 'https://www.blellow.co.za',
    CommunicationPreference: 'whatsapp',
    Whatsapp: {
      SendToNumber: '27847711001',
    },
    EmailService: {
      URL: '',
      Username: '',
      Password: '',
      SendTo: 'blellow.heath@gmail.com',
    },
    Icon: 'images/blellowstudio/blellowstudiologo.png',
    DateFormats: {
      parse: {
        dateInput: 'dd MMMM yyyy',
      },
      display: {
        dateInput: 'dd MMMM yyyy',
        monthYearLabel: 'MMMM yyyy',
        dateA11yLabel: 'dd MMMM yyyy',
        monthYearA11yLabel: 'MMMM yyyy',
      },
    },
  },
  ColorConfig: {
    primary: '#c28903',
    secondary: '#705c2a',

    headerBackground: '#08202b',
    heroGradient: 'linear-gradient( rgba(13, 14, 13, 0.5),rgba(5, 5, 5, 0.5))',
    headerScroll: '#0c3041',
    contactCard: '#08202b',
    background: '#eeebeb',
    text: '#292223',
    lightGrey: '#eeebeb',
    headingFont: "'Poppins', sans-serif",
    shadow: '0 15px 40px rgba(0, 76, 63, 0.12)',
    radius: '12px',
    dark: '#292223',
    inputFields: 'rgba(0, 143, 117, 0.10)',
    inputFieldsBoxShadow: 'rgba(0, 143, 117, 0.15)',
    errorMessage: '#C43D3D',
    reviewStar: '#D99A00',
    captionBackground: 'rgba(120, 120, 120, 0.75)',
  },
  HeaderConfig: {
    imgUrl: 'images/blellowstudio/whiteblellowlogo.png',
    logoAlt: 'Blellow Studio logo',
    menuButtonAriaLabel: 'Open navigation menu',
    social: {
      facebook: null,
      instagram: null,
      linkedin: null,
      youtube: null,
    },
    headerBtn: 'Start a Project',
  },
  HeroConfig: {
    id: 'home',
    navName: 'Home',
    subtitle: 'Digital and Physical Creation',
    title: 'Web Development,\n3D Modelling & Printing',
    description: [
      'Blellow Studio helps turn ideas into websites, practical 3D models or finished printed products.',
      'Work directly with us from the first concept through to a result that is ready to use.',
    ],
    primaryButton: 'Explore Services',
    secondaryButton: 'Start a Project',
    imgUrl: 'images/blellowstudio/blellowhero.jpg',
  },
  AboutConfig: null,
  FeatureConfig: {
    id: 'services',
    navName: 'Services',
    subtitle: 'What We Do',
    title: 'Blellow Studio Services',
    description:
      'Support for websites, 3D models and physical prototypes, tailored to what your project needs.',
    featureButton: 'View Details',
    backToLabel: 'Back to Services',
    detailsbuttonLabel: 'Start a Project',
    cards: [
      {
        id: 'web-development',
        title: 'Web Development',
        description: 'Responsive websites built around your business and your customers.',
        details: [
          'Business websites and landing pages',
          'Responsive desktop and mobile layouts',
          'Clear, maintainable code',
          'Support for improvements and new features',
        ],
        optionsLabel: null,
        showOptions: false,
        options: [],
        checkinHeading: 'Project Approach',
        checkinDetails:
          'We define the right scope and build a website that is clear, useful and easy for your audience to use.',
        imgUrl: 'images/blellowstudio/blellowhero.jpg',
        images: [
          { srcUrl: 'images/blellowstudio/blellowhero.jpg', previewUrl: 'images/blellowstudio/blellowhero.jpg', alt: 'Blellow Studio' },
        ],
      },
      {
        id: '3d-printing',
        title: '3D Design & Printing',
        description: 'Physical prototypes and custom printed pieces made for your project.',
        details: [
          'Prototype and custom-part printing',
          'Print-ready file checks',
          'Material and finish recommendations',
          'Small-run and one-off projects',
        ],
        optionsLabel: null,
        showOptions: false,
        options: [],
        checkinHeading: 'Project Approach',
        checkinDetails:
          'Share your model or idea and we will confirm the best route to a successful printed result.',
        imgUrl: 'images/blellowstudio/blellowhero.jpg',
        images: [
          { srcUrl: 'images/blellowstudio/blellowhero.jpg', previewUrl: 'images/blellowstudio/blellowhero.jpg', alt: 'Blellow Studio logo' },
        ],
      },
    ],
  },
  ActivitiesConfig: {
    id: 'why-blellow',
    navName: 'Why Blellow',
    subtitle: 'Built Around Your Project',
    title: 'Practical Creative Support',
    description:
      'A flexible studio service for businesses, makers and people with an idea worth developing.',
    cards: [
      {
        title: 'Clear Communication',
        description: 'Straightforward discussions about your brief, options and next steps.',
        icon: 'fa-solid fa-comments',
        imgUrl: '',
      },
      {
        title: 'Digital Craft',
        description: 'Thoughtful web and 3D work focused on function as well as appearance.',
        icon: 'fa-solid fa-laptop-code',
       imgUrl: '',
      },
      {
        title: 'From Concept to Object',
        description: 'A connected process from 3D model to physical printed piece.',
        icon: 'fa-solid fa-cube',
        imgUrl: '',
      },
      {
        title: 'Custom Solutions',
        description: 'Services tailored to your project rather than a one-size-fits-all package.',
        icon: 'fa-solid fa-screwdriver-wrench',
        imgUrl: '',
      },
    ],
  },
  GalleryConfig: {
    id: 'gallery',
    navName: 'Gallery',
    subtitle: 'Blellow Studio',
    title: 'Our Work',
    images: [
      { srcUrl: 'images/blellowstudio/blellowhero.jpg', previewUrl: 'images/blellowstudio/blellowhero.jpg', alt: 'Blellow Studio' },
    ],
  },
  ContactConfig: {
    id: 'contact',
    navName: 'Contact',
    subtitle: 'Get In Touch',
    title: "Let's Build Something",
    description:
      'Tell us about your website, 3D modelling or printing project and we will discuss the best next step.',
    cardTitle: 'Contact Blellow Studio',
    phoneLabel: 'Phone',
    addressLabel: 'Service Area',
    emailLabel: 'Email',
    address: {
      icon: 'fas fa-location-dot',
      addressLines: ['Gqeberha','South Africa', 'Remote and local projects welcome'],
      mapUrl: 'https://maps.app.goo.gl/jSfqfKBBCFF6firV7',
      embedMapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d251696.5270480272!2d25.365378098148703!3d-33.80116961366015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e7b290045ffd62b%3A0x86fd2337cd894226!2sGqeberha!5e1!3m2!1sen!2sza!4v1787834704925!5m2!1sen!2sza',
    },
    phones: [
      {
        icon: 'fas fa-phone',
        label: 'Mischka',
        number: '084 771 1001',
        link: 'tel:+27847711001',
      },
    ],
    email: {
      icon: 'fas fa-envelope',
      emailAddress: 'blellow.heath@gmail.com',
      emailLink: 'mailto:blellow.heath@gmail.com',
    },
    buttonText: 'Start a Project',
  },
  ReviewConfig: {
    id: 'review',
    navName: null,
    subtitle: 'Client Feedback',
    title: 'What Clients Say',
    reviews: [] as Array<{ rating: number; review: string; author: string }>,
  },
  BookingConfig: {
    id: 'enquire',
    navName: 'Enquire',
    subtitle: 'Start a Project',
    title: 'Tell Us About Your Idea',
    description: 'Share a few details and Blellow Studio will get back to you as soon as possible.',
    panelTitle: 'Ready to begin?',
    panelDescription: 'Send your project details to start the conversation.',
    detailsTitle: 'Project details',
    detailsDescription: 'Please fill in the details below.',
    submitButtonText: 'Send Project Enquiry',
    errorMessages: {
      required: '{field} is required.',
      email: 'Please enter a valid email address.',
      minLength: 'Minimum length is {min}.',
      maxLength: 'Maximum length is {max}.',
      pattern: 'Invalid format.',
      arrivalPast: 'Date cannot be in the past.',
      departurePast: 'Date cannot be in the past.',
      departureBeforeArrival: 'End date must be after the start date.',
    },
    messageTemplates: {
      email: {
        subject: 'New Blellow Studio enquiry from {name}',
        body: 'Service: {service}\n\n{message}',
      },
      whatsapp:
        'Hello Mischka, I am {name} and I would like to enquire about {service}.\n\nProject details:\n{message}\n\nMy contact details are:\nEmail: {email}\nPhone: {phone}',
    },
    fields: [
      {
        name: 'name',
        label: 'Name',
        type: 'text',
        placeholder: 'Enter your name',
        validation: { required: true, minLength: 2 },
        order: 1,
        columns: 1,
      },
      {
        name: 'email',
        label: 'Email',
        type: 'email',
        placeholder: 'Enter a valid email address',
        validation: { required: false, email: true },
        order: 2,
        columns: 1,
      },
      {
        name: 'phone',
        label: 'Phone',
        type: 'tel',
        placeholder: '084 123 4567',
        order: 3,
        columns: 1,
      },
      {
        name: 'service',
        label: 'Service',
        type: 'select',
        placeholder: 'Select a service',
        validation: { required: true },
        options: [
          { value: 'Web Development', label: 'Web Development' },
          { value: '3D Design & Printing', label: '3D Design & Printing' },
          { value: 'Custom Project', label: 'Custom Project' },
        ],
        order: 4,
        columns: 1,
      },

      {
        name: 'message',
        label: 'Project Details',
        type: 'textarea',
        placeholder: 'Describe your idea, requirements and any important details.',
        rows: 5,
        validation: { required: true, minLength: 10, maxLength: 500 },
        order: 7,
        columns: 2,
      },
    ],
  },
  FooterConfig: {
    brandName: 'Blellow Studio',
    description: 'Web development, 3D modelling and 3D printing.',
    quickLinksTitle: 'Quick Links',
    contactTitle: 'Contact',
    copyright: '(c) 2026 Blellow Studio. All rights reserved.',
  },
};
